export default [
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/error/Error404.vue'),
    meta: {
      pageTitle: '404',
      layout: 'full',
      resource: 'auth',
      action: 'read',
    },
  },
  {
    path: '/not-authorized',
    name: 'not-authorized',
    component: () => import('@/views/error/NotAuthorized.vue'),
    meta: {
      pageTitle: '401',
      layout: 'full',
      resource: 'auth',
      action: 'read',
    },
  },
]
